/**
 * DreamPay Private API
 * Private API v2 - Current version with JWT authentication, role-based access control, and enhanced security features.
 *
 * The version of the OpenAPI document: v2
 * Contact: suporte@dreampay.com.br
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface EstablishmentV2 {
  id?: number;
  establismentName?: string;
  commercialName?: string | null;
  softDescriptor?: string | null;
  address?: string | null;
  state?: string | null;
  zipCode?: string | null;
  city?: string | null;
  countryId?: number;
  vatNumber?: string | null;
  iban?: string | null;
  swiftCode?: string | null;
  phoneNumber?: string | null;
  emailAddress?: string | null;
  websiteUrl?: string | null;
  instagramUrl?: string | null;
  logo?: string | null;
  comission?: number;
  deleted?: boolean;
  apiKey?: string;
  signUpDate?: string;
  warrantyValueEur?: number;
  contractUuid?: string | null;
  signedContractUrl?: string | null;
  active?: boolean;
  showInApp?: boolean;
  currencyCode?: string | null;
  averageSaleValue?: number;
  bankName?: string;
  bankAddress?: string;
  pixKey?: string | null;
}
